import { AgenturModel } from 'app/models/agentur.model';
import { AgenturStore } from '../agentur.store';
import { computed, makeObservable, observable, runInAction } from 'mobx';
import _ from 'lodash';
import { BaseUiStore } from './base.ui.store';
import { AgtFitnessPdfModel, KvAgtFitnesspdfStore } from '../kv.agt.fitnesspdf.store';

export class FittnessPdfVM {
	agt: AgenturModel;
	@observable
	items: AgtFitnessPdfModel;

	constructor(agt: AgenturModel, item: AgtFitnessPdfModel) {
		makeObservable(this);
		this.agt = agt;
		this.items = item;
	}

	@computed
	get hasTracker() {
		return this.items.trackerBms.length > 0;
	}

	@computed
	get trackerBms() {
		return _.sortBy(this.items.trackerBms, (b) => b).reverse();
	}

	@computed
	get hasPlan() {
		return this.items.planBms.length > 0;
	}

	@computed
	get planBms() {
		return this.items.planBms;
	}
}

export class AgtFitnesspdfUiStore extends BaseUiStore<FittnessPdfVM> {
	name = 'AgtFitnesspdfUiStore';
	kvAgtFitnesspdfStore: KvAgtFitnesspdfStore;
	agenturStore: AgenturStore;

	constructor(agenturStore: AgenturStore, kvAgtFitnesspdfStore: KvAgtFitnesspdfStore) {
		super();
		makeObservable(this);
		this.kvAgtFitnesspdfStore = kvAgtFitnesspdfStore;
		this.agenturStore = agenturStore;
	}

	getByAgtId(agtId: number): FittnessPdfVM | undefined {
		return this.items.find((i) => i.agt.agtId === agtId);
	}

	async _baseLoad() {
		const data = await this.kvAgtFitnesspdfStore.load();
		const agts = await this.agenturStore.findAll();
		const res: FittnessPdfVM[] = [];
		for (const agt of agts) {
			const kvs = data.find((d) => d.agtId === agt.agtId);
			if (kvs) {
				//kvs.forEach((kv) => {
				const vm = new FittnessPdfVM(agt, kvs);
				res.push(vm);
				//});
			}
		}
		runInAction(() => {
			this.items = res;
		});
	}
}
